import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button, Checkbox, Drawer, Form, Select, Tabs, Tooltip } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { CheckCircle, ChevronDown, ChevronLeft, ChevronUp, CloseIcon, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import ListingAgreement from '../../components/ListingAgreement/ListingAgreement';
import PinDrawerWithoutButton from '../../components/PinDrawerWithoutButton/PinDrawerWithoutButton';
import BuyOrder from '../../components/SecondaryTrade/BuyOrder';
import SellOrder from '../../components/SecondaryTrade/SellOrder';
import { Images } from '../../config/images';
import { formatePhoneNumber } from '../../utils/formatPhoneNumber';
import { getBankLogo } from '../../utils/getBankLogo';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import ResetPin from '../Account/Profile/Modals/ResetPin';
import { BuyReviewData, BuySuccessData, SellReviewData, SellSuccessData } from './TradeData';

const TradeDrawer = (props) => {
  const { quickBuyPropertyData, isSingleTab, featchData, quickBuySecondaryOptions } = props;
  const [shareValue, setShareValue] = useState();
  const [sellPrice, setSellPrice] = useState();
  const [reviewData, setReviewData] = useState(BuyReviewData);
  const [successData, setSuccessData] = useState(BuySuccessData);
  const [, setBankModalOpen] = useState(false);
  const [bankOpen, setBankOpen] = useState(false);
  const loading = useSelector((state) => state.secondaryPlaceBid.loading);
  const userProfileData = useSelector((state) => state.userData.userData);
  const phoneNumber = ['+1', formatePhoneNumber(userProfileData?.phoneNumber)];
  function handleSellClick() {
    setReviewData(SellReviewData);
    setSuccessData(SellSuccessData);
    props.modalState('StepThree');
  }
  const orderRef = useRef();
  const linkText = 'My Account>Account Balances';
  const linkPath = '/account/transactions';
  const openLink = () => {
    window.location.href = linkPath;
  };
  const {
    pin,
    loading: hookLoading,
    numberOfShare,
    isMaxRangeError,
    isMinRangeError,
    minButtonValue,
    sharesRemainingToPurchase,
    limitPrice,
    LowestAskPrice,
    duration,
    totalInvestment,
    transactionFee,
    totalPurchase,
    isEditPayment,
    walletsData,
    selectedPaymentMethod,
    isTurmAndCondistion,
    partialFills,
    perSharePrice,
    userPurchasedShare,
    activeTab,
    setActiveTab,
    setPartialFills,
    setPin,
    resetPin,
    setResetPin,
    handleVerifyPin,
    handleForgotPin,
    setNumberOfShare,
    setLimitPrice,
    setDuration,
    handleSelectPaymentMethod,
    setIsTurmAndCondistion,
    handlePlaceBid,
    handleSellOrder,
    setLoading,
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
  } = quickBuySecondaryOptions;
  return (
    <>
      <ResetPin phoneNumber={phoneNumber} mail={userProfileData?.email} setOpen={resetPin} setClose={() => setResetPin(false)} />
      {props.open === 'StepOne' && (
        <PinDrawerWithoutButton
          onCancel={() => {
            props.modalState();
            setPin('');
          }}
          open={props.open === 'StepOne'}
          pin={pin}
          loading={hookLoading}
          handleForgotPin={handleForgotPin}
          setPin={setPin}
          setLoading={setLoading}
          onSuccess={handleVerifyPin}
        />
      )}
      <Drawer
        className='buy-order footer-shadow quickbuy--drawer'
        width='100%'
        title={<p className='subhead-2 mb-0 ml-40 text-center'>Create order</p>}
        onClose={() => props.modalState()}
        open={props.open === 'StepTwo'}
        closeIcon={<CloseIcon />}
        footer={
          <>
            {activeTab === '1' && (
              <Button
                type='primary'
                className='w-100'
                onClick={() => {
                  props.modalState('StepThree');
                  setReviewData(BuyReviewData);
                  props.modalState('StepThree');
                }}
                disabled={!numberOfShare || !limitPrice || !duration || isMaxRangeError || Number(numberOfShare) % 1 !== 0 || Number(limitPrice) <= 0}
              >
                Preview order
              </Button>
            )}
            {activeTab === '2' && (
              <Button
                disabled={
                  !numberOfShare ||
                  !limitPrice ||
                  !duration ||
                  numberOfShare > userPurchasedShare ||
                  Number(numberOfShare) % 1 !== 0 ||
                  Number(limitPrice) <= 0 ||
                  totalPurchase <= 0
                }
                type='primary'
                className='w-100'
                onClick={handleSellClick}
              >
                Preview order
              </Button>
            )}
          </>
        }
      >
        <div className='buy-order-header'>
          <div className='header__img'>
            <LazyLoadImage
              onError={(element) => {
                element.target.src = Images.noPropertyFoundImage;
              }}
              src={quickBuyPropertyData?.images?.image1}
            />
          </div>
          <div className='header__content'>
            <p className='subhead-2 text-copper mb-0'>{quickBuyPropertyData?.propertyName || ''}</p>
            <div className='name-type mb-12'>
              <span className='fz-12'>{`${quickBuyPropertyData?.cityName || ''}, ${quickBuyPropertyData?.stateName || ''}`}</span>
              <span className='fz-12'>• </span>
              <span className='fz-12'>{quickBuyPropertyData?.propertyType || ''}</span>
            </div>
            <div className='share-details'>
              <div className='block'>
                <span className='text-taupe-80'>Last price</span>
                <span className='subhead-3'>{`$${getUsCurrencyFormatWithoutDecimal(quickBuyPropertyData?.lastTradedPrice || 0)}`}</span>
              </div>
              <div className='block'>
                <span className='text-taupe-80'>All time</span>
                <span className='subhead-3'>{`${Number(quickBuyPropertyData?.allTime) > 0 ? '+' : ''} ${getUsCurrencyFormat(
                  quickBuyPropertyData?.allTime || 0
                )}%`}</span>
              </div>
              <div className='block'>
                <span className='text-taupe-80'>
                  Div yield
                  <Tooltip
                    placement='bottom'
                    title='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.'
                  >
                    <span>
                      <Information className='cursor-pointer' verticalAlign='middle' marginLeft='4px' color='#1A1519' />
                    </span>
                  </Tooltip>
                </span>
                <span className='subhead-3'>{`${getUsCurrencyFormat(quickBuyPropertyData?.dividendYield || 0)} %`}</span>
              </div>
            </div>
          </div>
        </div>
        {isSingleTab ? (
          <BuyOrder
            ref={orderRef}
            numberOfShare={numberOfShare}
            isMaxRangeError={isMaxRangeError}
            isMinRangeError={isMinRangeError}
            minButtonValue={minButtonValue}
            sharesRemainingToPurchase={sharesRemainingToPurchase}
            setNumberOfShare={setNumberOfShare}
            limitPrice={limitPrice}
            setLimitPrice={setLimitPrice}
            LowestAskPrice={LowestAskPrice}
            duration={duration}
            quickBuyPropertyData={quickBuyPropertyData}
            setDuration={setDuration}
            totalInvestment={totalInvestment}
            transactionFee={transactionFee}
            totalPurchase={getUsCurrencyFormat(totalPurchase)}
            partialFills={partialFills}
            setPartialFills={setPartialFills}
          />
        ) : (
          <Tabs
            defaultActiveKey='1'
            onChange={(key) => {
              setActiveTab(key);
              if (key === '2') {
                setNumberOfShare(userPurchasedShare.toString());
                setLimitPrice('');
                setDuration('');
                orderRef.current.resetFields();
              } else {
                setNumberOfShare(minButtonValue.toString());
                setLimitPrice('');
                setDuration('');
                orderRef.current.resetFields();
              }
            }}
            items={[
              {
                label: 'Buy',
                key: '1',
                children: (
                  <BuyOrder
                    ref={orderRef}
                    numberOfShare={numberOfShare}
                    isMaxRangeError={isMaxRangeError}
                    isMinRangeError={isMinRangeError}
                    minButtonValue={minButtonValue}
                    sharesRemainingToPurchase={sharesRemainingToPurchase}
                    setNumberOfShare={setNumberOfShare}
                    limitPrice={limitPrice}
                    setLimitPrice={setLimitPrice}
                    LowestAskPrice={LowestAskPrice}
                    duration={duration}
                    quickBuyPropertyData={quickBuyPropertyData}
                    setDuration={setDuration}
                    totalInvestment={totalInvestment}
                    transactionFee={transactionFee}
                    totalPurchase={getUsCurrencyFormat(totalPurchase)}
                    partialFills={partialFills}
                    setPartialFills={setPartialFills}
                  />
                ),
              },
              {
                label: 'Sell',
                key: '2',
                children: (
                  <>
                    <SellOrder
                      ref={orderRef}
                      shareValue={shareValue}
                      setShareValue={setShareValue}
                      sellPrice={sellPrice}
                      setSellPrice={setSellPrice}
                      duration={duration}
                      setDuration={setDuration}
                      userPurchasedShare={userPurchasedShare}
                      numberOfShare={numberOfShare}
                      setNumberOfShare={setNumberOfShare}
                      limitPrice={limitPrice}
                      setLimitPrice={setLimitPrice}
                      LowestAskPrice={LowestAskPrice}
                      quickBuyPropertyData={quickBuyPropertyData}
                      totalInvestment={totalInvestment}
                      transactionFee={transactionFee}
                      totalPurchase={getUsCurrencyFormat(totalPurchase)}
                      partialFills={partialFills}
                      setPartialFills={setPartialFills}
                    />
                  </>
                ),
              },
            ]}
          />
        )}
      </Drawer>

      <Drawer
        className='review-buy-order footer-shadow quickbuy--drawer'
        width='100%'
        title={
          <>
            <ChevronLeft className='cursor-pointer' onClick={() => props.modalState('StepTwo')} />
            <span className='subhead-2 mb-0 ml-24 text-center title'>{reviewData?.title || ''}</span>
          </>
        }
        onClose={() => props.modalState()}
        open={props.open === 'StepThree'}
        closeIcon={<CloseIcon />}
        footer={
          <Button
            loading={loading}
            disabled={!isTurmAndCondistion}
            type='primary'
            className='w-100'
            onClick={() => (activeTab === '1' ? handlePlaceBid() : handleSellOrder())}
          >
            Place bid
          </Button>
        }
      >
        <p className='fw-600'>Investment details</p>
        <div className='d-flex flex-column g-16 fz-14'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Shares</span>
            <span>{numberOfShare || ''}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Price per share</span>
            <span>{`$${getUsCurrencyFormat(limitPrice || '')}`}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total investment</span>
            <span>{`$${getUsCurrencyFormat(totalInvestment || '')}`}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Platform fee</span>
            <span>$2.50</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
            <span>{`$${transactionFee || ''}`}</span>
          </div>
        </div>
        <hr className='mb-16 mt-16' />
        <div className='d-flex flex-column g-16 fz-14'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total purchase (USD)</span>
            <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || '')}`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <Tooltip
              title={
                <>
                  <p>
                    A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor cancels
                    it.
                  </p>
                  <p className='mb-0'>
                    A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is placed.
                    All “good for the day” orders will expire at 11:59 PM EST on the day they were placed.
                  </p>
                </>
              }
            >
              <span className='text-taupe-80 underline cursor-pointer'>Duration</span>
            </Tooltip>
            <span>{duration}</span>
          </div>
        </div>
        <p className='fw-600 mt-32'>Payment details</p>
        {!!isEditPayment ? (
          <FloatingLabel label='Payment method' inputId='bankSelect' inputValue={selectedPaymentMethod?.id} alwaysBig>
            <div id='bank-anchor' />
            <Form.Item className='mb-0' name='bankSelect'>
              <Select
                id='bankSelect'
                onChange={(value) => {
                  value !== -1 ? handleSelectPaymentMethod(value) : setBankModalOpen(true);
                }}
                defaultValue={selectedPaymentMethod?.id}
                value={selectedPaymentMethod?.id}
                menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' />}
                getPopupContainer={() => document.getElementById('bank-anchor')}
                onDropdownVisibleChange={() => setBankOpen(!bankOpen)}
                suffixIcon={bankOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
              >
                {walletsData?.map((item) => (
                  <Select.Option value={item.id}>
                    {getBankLogo(item?.brandName)} {item?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : item?.brandName || ''}{' '}
                    {item?.sourceType !== 'Wallet' && item?.sourceType !== 'add new' && `*** ${item.lastFourDigit || ''}`}
                    {item?.sourceType === 'Wallet' && '$'}
                    {item?.sourceType === 'Wallet' ? (
                      totalInvestment > item?.balance ? (
                        <span className='error-text'>Insufficient balance</span>
                      ) : (
                        <span>{`${
                          Number(item?.balance)
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',') || ''
                        }`}</span>
                      )
                    ) : (
                      <span>{`${
                        Number(item?.balance)
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',') || ''
                      }`}</span>
                    )}
                  </Select.Option>
                ))}
              </Select>
              {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
                <div className='pt-10 error-text'>
                  <span style={{ cursor: 'pointer' }} onClick={openLink}>
                    Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                  </span>
                </div>
              )}
            </Form.Item>
          </FloatingLabel>
        ) : (
          <>
            <div className='d-flex g-8 align-items-center'>
              {getBankLogo(selectedPaymentMethod?.brandName)}
              <span className='fz-16'>
                {selectedPaymentMethod?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : selectedPaymentMethod?.brandName || ''}
              </span>
              {selectedPaymentMethod?.sourceType !== 'Wallet' && (
                <span className='text-taupe-80 fz-16'>{`*** ${selectedPaymentMethod?.lastFourDigit || ''}`}</span>
              )}
              {selectedPaymentMethod?.sourceType === 'Wallet' &&
              selectedPaymentMethod?.balance !== undefined &&
              selectedPaymentMethod?.balance !== null ? (
                totalInvestment > selectedPaymentMethod?.balance ? (
                  <span className='text-taupe-80 fz-16 error-text'>Insufficient balance</span>
                ) : (
                  <span className='text-taupe-80 fz-16'>{`$${Number(selectedPaymentMethod?.balance)
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}</span>
                )
              ) : null}
            </div>
            {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
              <div className='pt-10 error-text'>
                <span style={{ cursor: 'pointer' }} onClick={openLink}>
                  Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                </span>
              </div>
            )}
          </>
        )}
        <div className='d-flex mt-48'>
          <Checkbox checked={isTurmAndCondistion} onChange={(value) => setIsTurmAndCondistion(value.target.checked)} className='mr-16' />
          <span className='cursor-pointer fz-14'>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>I have read and accept the </span>
            <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
              Terms of Use
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, the </span>
            <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
              Regulation A Investment Disclosure
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, and </span>
            <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
              Privacy Policy
            </Link>
            .
          </span>
        </div>
      </Drawer>

      <Drawer
        className='success footer-shadow quickbuy--drawer'
        width='100%'
        title={false}
        onClose={() => featchData()}
        open={props.open === 'success'}
        closable={false}
        footer={false}
      >
        <div className='mb-16 success__vector'>
          <img src={Images.success} alt='success vector art' />
        </div>
        <h4 className='success__title fz-24'>{activeTab === '2' ? SellSuccessData?.title : successData?.title || ''}</h4>
        <p className='mb-48 text-taupe fz-16'>
          {activeTab === '2'
            ? `You have successfully placed a sell order for ${numberOfShare || ''} shares ($${perSharePrice || ''} each) of ${
                quickBuyPropertyData?.propertyName
              }. You will be notified through email about any progress made toward your order.`
            : `You have successfully requested to buy ${numberOfShare} shares ($${perSharePrice} each) of ${quickBuyPropertyData?.propertyName}. You will be notified through email about any progress made toward your buy order.`}
        </p>
        <Button
          type='primary'
          className='w-100'
          onClick={() => {
            featchData();
          }}
        >
          Done
        </Button>
      </Drawer>

      {isTOSModal && <ListingAgreement isOpen={isTOSModal} onClose={onTOSModalClose} onAgreementAccept={onTOSAgreementSuccess} />}
    </>
  );
};

export default TradeDrawer;
